"use client";

import type React from "react";
import { useEffect, useState } from "react";

import { HelpEnhance } from "@/help/HelpEnhance";
import { HelpSearch } from "@/help/HelpSearch";
import { HelpToc } from "@/help/HelpToc";

const MAIN_SELECTOR = "#main";

export function HelpApp(): React.ReactElement {
  const [query, setQuery] = useState("");

  useEffect(() => {
    const q = query.trim().toLowerCase();
    const main = document.querySelector(MAIN_SELECTOR);
    if (!(main instanceof HTMLElement)) return;

    main.querySelectorAll<HTMLElement>(".help-section").forEach((el) => {
      const title = (el.dataset.helpTitle ?? "").toLowerCase();
      const summary = (el.dataset.helpSummary ?? "").toLowerCase();
      const body = (el.textContent ?? "").toLowerCase();
      const ok = !q || `${title} ${summary} ${body}`.includes(q);
      el.classList.toggle("hidden", !ok);
    });
  }, [query]);

  return (
    <>
      <HelpEnhance rootSelector={MAIN_SELECTOR} />
      <HelpSearch className="mb-4" value={query} onChange={setQuery} />
      <HelpToc />
    </>
  );
}
